export default "__VITE_ASSET__DPpbNf_$__"